module.exports = __webpack_public_path__ + "img/us.d2d1b784.png";